import React, {Component} from 'react';
import './App.css';
import './login/LoginPage.js';
import Api from './utils/Api';
import StaticFunctions from "./utils/StaticFunctions";
import Package from './utils/Package.js';
import LoadingSplash from './globalComponents/LoadingSplash';
import SupportedLanguages from './utils/entities/SupportedLanguages';
import LoginPage from './login/LoginPage';
import MainFrame from './mainFrame/MainFrame';
import KeepAlive from './utils/KeepAlive';
import {withTranslation, Trans} from 'react-i18next';
import ForgotPasswordPage from "./login/ForgotPasswordPage";
import Register from "./login/Register";
import RegisterSuccess from "./login/RegisterSuccess";
import InitPasswordPage from "./login/InitPasswordPage";

import './css/chosen.css';
import './css/bootstrap.css';
import './css/style.css';
import './css/animate.css';
import './css/jquery.dataTables.css';
import './css/responsive.dataTables.css';

const {detect} = require('detect-browser');
const browser = detect();

class App extends Component {

    constructor(props) {

        super(props);

        //  Load ID Compat
        this.loadCompat();

        this.api = new Api();
        this.package = new Package();

        this.state = {
            registerMail: null,
            subPage: null,
            mail: null,
            code: null,
            loggedIn: null,
            timezones: null,
            languages: [],
            translations: null,
            urlParams: null
        };

        this.zskLinks = {
            homePage: 'https://www.zsk.de',
            imprint: '/impressum.php',
            policy: '/datenschutz.php',
            condition: '/agb.php',
            contact: '/serviceleistungen/kontakt.php#main-contact',
        };

        this.loadUrlParams = this.loadUrlParams.bind(this);
        this.handleGetParamRequests = this.handleGetParamRequests.bind(this);
        this.loadLanguages = this.loadLanguages.bind(this);
        this.loadTimezones = this.loadTimezones.bind(this);
        this.loadTranslations = this.loadTranslations.bind(this);
        this.addTranslation = this.addTranslation.bind(this);
        this.translateByKey = this.translateByKey.bind(this);
        this.getCurrentLanguageData = this.getCurrentLanguageData.bind(this);

        this.setUrlStateParams = this.setUrlStateParams.bind(this);

    }

    componentWillMount() {

        this.loadUrlParams();
        this.loadLanguages();
        this.loadTimezones();
        this.loadTranslations();

    }

	setLanguage() {

		const i18n = this.props.i18n;
		const languages = this.state.languages;
		const urlParams = new URLSearchParams(window.location.search);
		const langCode = urlParams.get('lang') || null;
		const foundLang = (langCode) ? (StaticFunctions.findObjectInArray(languages, 'value', langCode) !== null) : null;

		if (langCode && foundLang) {
			urlParams.delete('lang');

			i18n.changeLanguage(langCode);
		}

	}

    loadUrlParams() {

        const url = new URL(window.location.href);
        if (!url.searchParams.has('v')) {
            url.searchParams.set('v', new Date().getTime());
            window.location.href = url.toString();
            return null;
        }

        if (window.location.href.indexOf('?') === -1) return null;

        const urlParams = {};
        const start = window.location.href.indexOf('?') + 1;

        let end = window.location.href.indexOf('#');
        let hash;

        end = (end === -1) ? undefined : end;

        let hashes = window.location.href.substring(start, end).split('&');

        for (let i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');

            urlParams[hash[0]] = decodeURI(hash[1]);
        }

        this.setState({
            subPage: (urlParams.show) ? urlParams.show : null,
            urlParams: (Object.keys(urlParams).length > 0) ? urlParams : null
        });

        this.handleGetParamRequests(urlParams);

    }

    handleGetParamRequests(urlParams) {

        if (urlParams === null) return null;

        if (urlParams.mail && urlParams.code) {
            const params = {
                action: 'auth',
                email: urlParams.mail,
                auth: urlParams.code
            };

            const callback = function (res) {
                if (res) {
                    this.setUrlStateParams(urlParams);
                } else {
                    const url = new URL(window.location.href);
                    if (!url.searchParams.has('v')) {
                        url.searchParams.set('v', new Date().getTime());
                        window.location.href = url.toString();
                    }
                }
            }.bind(this);

            this.api.request('RequestForgotPassword', params, callback, null);
        }

    }

    loadLanguages() {

        //  Verfügbare Sprachen laden.
        const supportedLanguages = new SupportedLanguages();

        this.setState({
            languages: supportedLanguages.getLanguages()
		}, () => {
			this.setLanguage();
		});

    }

    loadTimezones() {

        //  Zeitzonen laden.
        const callback = function(res) {
            if (res) {
                this.setState({timezones: res});
            }
        }.bind(this);

        this.api.request('GetTimezones', null, callback, null);

    }

    loadTranslations() {

        //  Translations laden.
        const callback = function(res) {
            if (res) {
                this.setState({translations: res});
            }
        }.bind(this);

        this.api.request('GetI18n', null, callback, null);

    }

    loadCompat() {

        if (!Array.prototype.find) {
            // eslint-disable-next-line
            Array.prototype.find = function(predicate) {
                if (this == null) {
                    throw new TypeError('Array.prototype.find called on null or undefined');
                }

                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }

                const list = Object(this);
                const length = list.length >>> 0;
                const thisArg = arguments[1];

                let value;

                for (let i = 0; i < length; i++) {
                    value = list[i];
                    if (predicate.call(thisArg, value, i, list)) {
                        return value;
                    }
                }

                return undefined;
            };
        }

    }

    setUrlStateParams(urlParams = null) {

        const subPage = (urlParams && urlParams.show) ? urlParams.show : null;
        const registerMail = (urlParams && urlParams.registerMail) ? urlParams.registerMail : null;

        this.setState({
            registerMail: registerMail,
            subPage: subPage,
            urlParams: urlParams
        });

    }

    addTranslation(key, language, originalValue = null) {

        if (!(key && language && this.state.translations)) return null;

        const lang = language.substring(0, 2);

        //  Prüft ob Sprache und TranslationKey auch nicht in den Translations sind.
        if (this.state.translations.hasOwnProperty(lang) && this.state.translations[lang].hasOwnProperty(key)) return null;

        //  Neuen Translation-Key hinzufügen.
        const params = {
            key: key,
            language: lang,
            originalValue: originalValue,
        };

        const callback = function (res) {
            if (res) {
                this.loadTranslations();
            }
        }.bind(this);

        this.api.request('AddI18n', params, callback, null);

    }

    translateByKey(key) {

        if (!key) return key;

        const i18n = this.props.i18n;
        const selectedLangauge = i18n.language ? i18n.language.substring(0, 2) : 'en';
        const value = i18n.getResource(selectedLangauge, 'translations', key);
        const translatedKey = this.props.t(key);
        const originalValue = (translatedKey !== key) ? translatedKey : null;

        if (typeof value === 'undefined') this.addTranslation(key, selectedLangauge, originalValue);

        return translatedKey;

    }

    getCurrentLanguageData(language) {

        const languages = this.state.languages;

        if (!languages) return null;

        let found = languages.find((lang) => { return lang.value === language; });

        if (found === undefined) {
            found = languages.find((lang) => { return lang.value === 'en'; });
        }

        return found;

    }

    /**
     * send keepalive and check, if the session is still active.
     * Modifies this.state.loggedIn after Callback
     */
    validateLogin() {

        if (this.state.loggedIn !== null) return;

        const callback = function(resp) {
            this.onLoggedInChange(resp && resp.logged_in === true);
        }.bind(this);

        KeepAlive.getInstance().sendKeepAlive(callback);
        KeepAlive.getInstance().start(callback);

    }

    onLoggedInChange(loggedIn) {

        this.setState({
			loggedIn: loggedIn
		}, () => {
			if (loggedIn && window.location.href.indexOf('?') !== -1) {
                const url = new URL(window.location.href);
                if (!url.searchParams.has('v')) {
                    url.searchParams.set('v', new Date().getTime());
                    window.location.href = url.toString();
                }
            }
		});

    }

    render() {

		if (!this.state.languages || !this.state.translations) return null;

        this.validateLogin();

        let appPage = null;

        if (this.state.loggedIn === true) {
            appPage = <MainFrame
                package={this.package.package}
                Timezones={this.state.timezones}
                languages={this.state.languages}
                translate={this.translateByKey}
                zskLinks={this.zskLinks}
                i18n={this.props.i18n}
                browser={browser}
                getCurrentLanguageData={this.getCurrentLanguageData}
            />;
        } else {
            if (this.state.subPage === 'register') {
                appPage = <Register
                    languages={this.state.languages}
                    translate={this.translateByKey}
                    zskLinks={this.zskLinks}
                    i18n={this.props.i18n}
                    setUrlStateParams={this.setUrlStateParams}
                />;
            } else if (this.state.subPage === 'registersuccsess') {
                if (this.state.registerMail) {
                    appPage = <RegisterSuccess
                        registerMail={this.state.registerMail}
                        languages={this.state.languages}
                        translate={this.translateByKey}
                        zskLinks={this.zskLinks}
                        i18n={this.props.i18n}
                        setUrlStateParams={this.setUrlStateParams}
                    />;
                } else {
                    this.setUrlStateParams();
                }
            } else if (this.state.subPage === 'initpassword') {
                if (this.state.registerMail) {
                    appPage = <InitPasswordPage
                        registerMail={this.state.registerMail}
                        languages={this.state.languages}
                        translate={this.translateByKey}
                        zskLinks={this.zskLinks}
                        i18n={this.props.i18n}
                        setUrlStateParams={this.setUrlStateParams}
                    />;
                } else {
                    this.setUrlStateParams();
                }
            } else {
                const mail = (this.state.urlParams && this.state.urlParams.mail) ? this.state.urlParams.mail : '';
                const code = (this.state.urlParams && this.state.urlParams.code) ? this.state.urlParams.code : '';

                if (mail && code) {
                    appPage = <ForgotPasswordPage
                        mail={mail}
                        code={code}
                        languages={this.state.languages}
                        translate={this.translateByKey}
                        zskLinks={this.zskLinks}
                        i18n={this.props.i18n}
                        setUrlStateParams={this.setUrlStateParams}
                    />;
                } else {
                    appPage = <LoginPage
                        mail={mail}
                        languages={this.state.languages}
                        translate={this.translateByKey}
                        zskLinks={this.zskLinks}
                        i18n={this.props.i18n}
                        setUrlStateParams={this.setUrlStateParams}
                        onLoggedInChange={this.onLoggedInChange.bind(this)}
                    />;
                }
            }
        }

        return (
            <div className="App">
                {appPage}
            </div>
        );

    }

}

/*
    Polyfills
 */

if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function(searchElement, fromIndex) {

            if (this == null) throw new TypeError('"this" is null or not defined');

            //  1. Let O be ? ToObject(this value).
            const o = Object(this);

            //  2. Let len be ? ToLength(? Get(O, "length")).
            const len = o.length >>> 0;

            //  3. If len is 0, return false.
            if (len === 0) return false;

            //  4. Let n be ? ToInteger(fromIndex).
            //     If fromIndex is undefined, this step produces the value 0.)
            const n = fromIndex | 0;

            //  5. If n ≥ 0, then
            //  a. Let k be n.
            //  6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            let k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
            }

            //  7. Repeat, while k < len
            while (k < len) {
                //  a. Let elementK be the result of ? Get(O, ! ToString(k)).
                //  b. If SameValueZero(searchElement, elementK) is true, return true.
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }

                //  c. Increase k by 1.
                k++;
            }

            //  8. Return false
            return false;
        }
    });
}

if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

export default withTranslation('translations')(App);
